module.exports = __webpack_public_path__ + "static/media/ai-bg.14e27177.png";